import React from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';

const DisplayBrand = ({brand_name, t}) => {
  return brand_name ? <>{brand_name}</> : <>{t('dataTable.notSpecified')}</>;
};

DisplayBrand.propTypes = {
  t: PropTypes.func.isRequired,
  brand_name: PropTypes.string,
};

export default withTranslation('ticket')(DisplayBrand);
